export const MEMORY = "MEMORY";
export const BUSINESSTYPE = "individual";
